module.exports = __webpack_public_path__ + "img/folder.b5fca94e.svg";